const profile = {
    title: 'Kabine',
    myAddress: 'Adreslerim',
    historyOrders: 'sipariş geçmişi',
    messages: 'destekle sohbet et',
    bonuses: 'Bonuslarınız',
    share: 'bağlantıyı paylaş',
    delivery: 'Teslimat ve ödeme',
    aboutCompany: 'şirket hakkında',
    downloadApp: 'Uygulamayı indirin',
    signOut: 'Profilden çık',
    btnLogoutOk: 'Evet, dışarı çık',
    deleteAccount: 'Hesabı sil',
    modalDeleteAccount: {
        title: 'Hesabı sil?',
        btnDelete: 'Evet',
        btnClose: 'Hayir',
    },
    messageSignOut: 'Profilden çıktığınızda tüm ürünler sepetten silinir. Profilden çıkmak mı?',
    userPlaceholder: 'Kullanıcı adı',
    emailPlaceholder: 'email',
    copy: 'Bağlantı kopyalandı',
    history: {
        repeat: 'Siparişi tekrarla',
        more: 'devamı',
        order: 'Sipariş No.',
        cancel: 'siparişi iptal et',
        amount: 'Maliyet: ',
        deliveryAmount: 'teslimat: ',
        quantity: 'Sayı: ',
    },
    agreements: {
        ads: {
            labels: {
                bannerTitle:
                    'Kurye teslimat saati, kampanya ve indirimleri hakkında bilgi almak ister misiniz?',
                modalText:
                    'SMS, anlık bildirimler ve e-postalar yoluyla promosyon teklifleri almayı kabul ediyorsunuz. İstediğiniz zaman cihaz ayarlarınızdan devre dışı bırakabilirsiniz.',
                checkboxLabel:
                    'Sipariş durumları, promosyon teklifleri ve yeni ürünler hakkında push, SMS ve e-posta yoluyla bildirimler almayı kabul ediyorum',
            },
            buttons: {
                bannerAgree: 'İstek!',
                bannerDecline: 'İstemiyorum',
            },
        },
        privacyPolicy: {
            labels: {
                checkboxLabel: 'Kabul ediyorum',
            },
            buttons: {
                checkboxDocument: 'kişisel verilerin işlenmesi',
            },
        },
    },
};

export default profile;
